/**
 *
 * @module eventValue
 *
 */

import Check from 'check-types';
import Services from './../services/entry';

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    nonEmptyObject
} = Check.assert;

/**
 *
 * @class EventValue
 * @desc An interface that can be implemented by application developers to provide dynamic values
 *
 */
export default class EventValue {

    /**
     *
     * @param {*} value
     * @note we do not do any type checking here since the value being passed in can be a function or any value
     *
     */
    constructor(value) {

        /**
         *
         * @type {Function}
         * @desc stores a static value wrapped in a function or a reference to a function
         *
         */
        this.value = Check.function(value) ? value : () => value;

    }

    /**
     *
     * @access private
     * @param {Object} payload
     * @note this method returns the string stored in `this.value` or it executes the function stored in `this.value`
     * we pass the tracking parameters that were merged in `SDK.UserActivity.EventSchema` into this method and pass it
     * into the app developer provided function or it is ignored if `this.value` is a static value
     * @note this is marked `public` in the spec but the we invoke it in our implementation so it's marked `private`
     * @returns {Object}
     *
     */
    generateValue(payload) {

        const errorMessage = {
            method: 'EventValue.generateValue(payload)',
            get payload() {
                return `${this.method} payload should be a non-empty Object`;
            }
        };

        nonEmptyObject(payload, errorMessage.payload, InvalidArgumentException);

        return this.value(payload);

    }

}



// WEBPACK FOOTER //
// ./src/userActivity/eventValue.js